import React from 'react';
import "./page.css"
const PermitContent = (props) => {
  const { permit } = props;

  return (
    <>
      <div className="text-center boxOuter">
        <div className="colorBox">
          <div style={{ width: '180px' }} className="permitN">
            <h2 className="contentText fw-900">{permit && permit?.name}</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default PermitContent;
